import React from 'react';

const TOEFLJanuary2026DescriptionContent: React.FC = (props) => {
  return (
    <>
      <p>This practice test simulates the experience you will have taking the TOEFL on test day.</p>
      <p>When you finish the test, we will give you <strong>score estimates</strong> and <strong>detailed writing and speaking assessments</strong>, which tell you how well you would have done on test day.</p>
      <p>You'll also be able to <strong>review your answers</strong> and see video or text explanations for each question.</p>
    </>
  );
};

export default TOEFLJanuary2026DescriptionContent;
